<template>
  <SpringCard class="trustpilot-card">
    <div class="trustpilot-card__wrapper">
      <div
        class="trustpilot-card__header"
      >
        <div class="trustpilot-card__stars">
          <img
            v-for="index in 5"
            :key="`star-${index}`"
            :src="trustpilot_star_square"
            class="trustpilot-card__star"
            alt="Trustpilot start"
          >
        </div>
        <h6 class="trustpilot-card__title">
          {{ title }}
        </h6>
      </div>
      <div class="trustpilot-card__body">
        <span class="trustpilot-card__content"> {{ content }} </span>
      </div>
      <div class="trustpilot-card__splitter" />
      <div class="trustpilot-card__footer">
        {{ footer }}
      </div>
    </div>
  </SpringCard>
</template>

<script>
import { SpringCard } from 'spring-ui'
export default {
  name: 'TrustpilotCard',

  components: {
    SpringCard
  },

  props: {
    title: {
      type: String,
      required: true
    },
    content: {
      type: String,
      required: true
    },
    footer: {
      type: String,
      required: true
    }
  },

  data: function () {
    return {
      trustpilot_star_square: require('@/assets/svg/trustpilot_star_square.svg')
    }
  }
}
</script>

<style scoped lang="scss">
.trustpilot-card {
  @apply bg-white relative text-left mb-20;

  @screen md {
    @apply min-w-350 max-w-350;
  }

  @screen lg {
    @apply min-w-320 max-w-320;
  }

  &__wrapper {
    @apply flex flex-col px-20 pt-15 pb-10;
  }

  &__header {
    @apply h-95;
  }

  &__stars {
    @apply mb-15;
  }

  &__star {
    @apply inline h-20 w-20 mr-[2px];
  }

  &__title {
    @apply text-md font-bold mb-10;
  }

  &__body {
    @apply h-120;
  }

  &__content {
    @apply text-md;
  }

  &__splitter {
    @apply mt-5 mb-10 block w-60 h-[1px] bg-gray-300;
  }

  &__footer {
    @apply text-md font-bold;
  }
}
</style>
